import { useEffect } from 'react';
import { SocketEvents } from '@clinikchat/shared';
import toast from 'react-hot-toast';
import { getSocket } from '../lib/socket';

/**
 * Leave the open channel when it is deleted, or when this user's membership is
 * removed (the API sends CHANNEL_LEAVE to the removed member's own sockets).
 * Without the second case a removed member kept a working composer on a channel
 * they could no longer read.
 */
export function useLeaveWhenChannelGone(
  channelId: string | undefined,
  socketId: number,
  leave: () => void,
): void {
  useEffect(() => {
    const socket = getSocket();
    if (!socket || !channelId) return;
    const onDeleted = (payload: { channelId: string }) => {
      if (payload.channelId !== channelId) return;
      toast('This channel was deleted');
      leave();
    };
    const onRemoved = (payload: { channelId: string }) => {
      if (payload.channelId !== channelId) return;
      toast('You were removed from this channel');
      leave();
    };
    socket.on(SocketEvents.CHANNEL_DELETE, onDeleted);
    socket.on(SocketEvents.CHANNEL_LEAVE, onRemoved);
    return () => {
      socket.off(SocketEvents.CHANNEL_DELETE, onDeleted);
      socket.off(SocketEvents.CHANNEL_LEAVE, onRemoved);
    };
  }, [channelId, socketId, leave]);
}
